import ApiService from './ApiService'

class CalendarService {
  static async getEvents (dateStart, dateEnd) {
    return await ApiService.POST('/api/calendars/get-all-events.json', { start: dateStart, end: dateEnd })
  }

  static async getUsersEvents (userIds, dateStart, dateEnd) {
    return await ApiService.POST('/api/calendars/get-user-events.json', { user_id: userIds, start: dateStart, end: dateEnd })
  }

  static async getNextAppointments () {
    return await ApiService.GET('/api/calendars/next-appointments.json')
  }
}

export default CalendarService
